var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarHeading',[_vm._v("Software")]),_c('div',{staticClass:"flex relative z-0 overflow-hidden mt-4"},_vm._l((_vm.productLogos),function(logo,idx){return _c('div',{key:idx,attrs:{"logo":logo}},[_c('img',{staticClass:"w-8 md:w-12 mr-4",attrs:{"src":logo.url,"alt":logo.product,"title":logo.product}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }